import DOMPurify from 'dompurify'
import { useAppSelector } from '@/redux/hooks'
import { useTranslation } from 'react-i18next'

export function usePortalTranslate(editedCopies: Record<string, string>) {
  const { i18n } = useTranslation()

  const defaultCopies = useAppSelector(
    (store) => store.settingsApi.defaultCopies.response
  )

  const ecommerceCopies = useAppSelector(
    (store) => store.settingsApi.copies.response
  )
  const lang = sessionStorage.getItem('UILang') ?? 'EN'
  const copies = { ...ecommerceCopies, ...editedCopies }
  const translate = (key: string) => {
    const getCopy = (key: string) => {
      if (editedCopies[key] !== undefined) {
        return editedCopies[key] ?? ''
      } else if (copies[key] !== undefined) {
        return copies[key] ?? ''
      } else {
        return ''
      }
    }
    return DOMPurify.sanitize(getCopy(lang + '-' + key))
  }

  const selectedLanguage = i18n.language.toUpperCase()
  const trans = (key: string) => {
    const getCopy = (key: string) => {
      if (ecommerceCopies[key] !== undefined) {
        return ecommerceCopies[key] ?? ''
      }
      return ''
    }
    return DOMPurify.sanitize(getCopy(selectedLanguage + '-' + key))
  }

  const transDefault = (key: string) => {
    const getCopy = (key: string) => {
      if (defaultCopies[key] !== undefined) {
        return defaultCopies[key] ?? ''
      }
      return ''
    }
    return DOMPurify.sanitize(getCopy(lang + '-' + key))
  }

  return { translate, trans, transDefault }
}
